import { NumberField as NumericField } from 'ui'
import { ControlledField } from './ControlledField'
import { SigningFormFieldProps } from './Switcher'

export const NumberField = ({
  field,
  index,
  path,
  onPersist,
}: SigningFormFieldProps) => {
  return (
    <ControlledField
      onPersist={onPersist}
      path={path}
      index={index}
      field={field}
    >
      {({ field: formField, fieldState }) => {
        return (
          <NumericField
            inputStyle={{
              fontSize: 'inherit',
            }}
            id={field.id}
            className='rounded-none focus-visible:ring-black p-0'
            containerClassName='w-full h-full'
            ref={formField.ref}
            variant={'filled'}
            error={!!fieldState.error}
            formatOptions={{
              useGrouping: false,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }}
            value={formField.value}
            onChange={(value) => {
              formField.onChange(value)
              onPersist(value)
            }}
            placeholder={field.label}
          />
        )
      }}
    </ControlledField>
  )
}
